// This removes any issues with date ISO Strings being converted to local time
// Which often means dates / times are off by 1 hour due to time zones, and will
// cause the date to be whole years/months/days/quarters out

export const getUTCDateFromISOString = (date: string) =>
  new Date(new Date(date).toUTCString().substring(0, 25));
